module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("kNLVx"))).then(() => module.bundle.root('cI8hw'));